import * as angular from "angular";

angular
  .module('app.translate')
  .config(translateConfig);

/* @ngInject */
function translateConfig($translateProvider, $translatePartialLoaderProvider, triSettingsProvider) {
  const appLanguages = [
    {
      name: 'English',
      key: 'en'
    },
    {
      name: 'Hebrew',
      key: 'he'
    },
    {
      name: 'Portuguese',
      key: 'pt'
    },
    {
      name: 'Spanish',
      key: 'es'
    },
    {
      name: 'German',
      key: 'de'
    },
    {
      name: 'French',
      key: 'fr'
    }
  ];

  /**
   *  each module loads its own translation file - making it easier to create translations
   *  also translations are not loaded when they aren't needed
   *  each module will have a i18n folder that will contain its translations
   */
  $translateProvider.useLoader('$translatePartialLoader', {
    urlTemplate: 'i18n/{part}/{lang}.json'
  });

  $translatePartialLoaderProvider.addPart('default');

  // make sure all values used in translate are sanitized for security
  $translateProvider.useSanitizeValueStrategy('escapeParameters');

  // cache translation files to save load on server
  $translateProvider.useLoaderCache(true);

  // setup available languages in angular translate & triangular
  const angularTranslateLanguageKeys = [];
  for (let language in appLanguages) {
    // add language key to array for angular translate
    angularTranslateLanguageKeys.push(appLanguages[language].key);

    // tell triangular that we support this language
    triSettingsProvider.addLanguage({
      name: appLanguages[language].name,
      key: appLanguages[language].key
    });
  }

  // use a fallback language when no key found
  $translateProvider.fallbackLanguage('en');
  $translateProvider.preferredLanguage('en');


  /**
   *  try to detect the users language by checking the following
   *      navigator.language
   *      navigator.browserLanguage
   *      navigator.systemLanguage
   *      navigator.userLanguage
   */
  $translateProvider
    .registerAvailableLanguageKeys(angularTranslateLanguageKeys, {
      'en_US': 'en',
      'en_UK': 'en'
    })
    .use('en');

  // store the users language preference in a cookie
  $translateProvider.useLocalStorage();
}
